import withCacheRequest from '../decorators/withCacheRequest';

import AjaxUtils from './ajaxUtils';

export const USER_DATA_TTL = 300; // 5 min

const updatePrivacyConsent = data => AjaxUtils.post('/v2/browser-privacy-consent', data);

const updateUserAnalytics = (userId, data) => AjaxUtils.patch(`${envConfig.PLATFORM_SERVER_URL}/v2/user-analytics/${userId}`, { ...data, userId }, true);

const fetchUserCompanyInfo = () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/company/me`, true);

const logout = () => AjaxUtils.delete(`${envConfig.PLATFORM_SERVER_URL}/v2/logout`, true);

const fetchReferralUsage = () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/account-referrals`, true);

const fetchUserRole = () => withCacheRequest('userRole', USER_DATA_TTL, () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/api/v1/accounts/get-role`, true));

const fetchContactLocations = query => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/filters/contactLocation?text=${query}`, true);

export {
  fetchContactLocations,
  fetchReferralUsage,
  fetchUserCompanyInfo,
  fetchUserRole,
  logout,
  updatePrivacyConsent,
  updateUserAnalytics,
};
